import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";

// Reactstrap components
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
} from "reactstrap";

// componente
import ModalJustificativa from "components/ModalJustificativa/ModalJustificativa";
import ModalCancelamentoRequerimento from "components/ModalCancelamentoRequerimento/ModalCancelamentoRequerimento";

// leaflet
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";

// style
import {
  table_translate,
  table_style,
} from "../../../constants/MaterialTable.js";

// helpers
import { formateDate, formateDateandTime } from "../../../helpers/formats";

// services
import { api_GET, api_POST } from "../../../services/api_service.js";
import { showMessage, showQuestion } from "../../../services/message.js";
import { CancelarRequerimentoByRequerimento } from "../../../services/requerimento_service.js";

// views
import FichaRequerimento from "views/Shared/Destino/FichaRequerimento";

//Context
import { useAuth } from "../../../context/auth";

export default function FichaDestino({ history, item, showAcoesGestor }) {
  const { session, setLoading, signOut, setupSistema } = useAuth();

  const [protocolo, set_protocolo] = useState(null);

  const [list_acoes, set_list_acoes] = useState(null);

  const [requerimento, set_requerimento] = useState(null);

  const [modal, setModal] = useState(false);

  const toggleModal = () => setModal(!modal);

  const [modalCancelamento, setModalCancelamento] = useState(false);
  const [itemCancelamento, setItemCancelamento] = useState(null);

  // Mapa
  const [modalMapaOpen, set_modalMapaOpen] = useState(false);
  const [centerMap, setCenterMap] = useState([0, 0]);
  const [positionMarker, setpositionMarker] = useState([0, 0]);
  const iconMarker = new L.Icon({
    iconUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
    iconRetinaUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-black.png",
  });
  const ChangeMap = ({ center, zoom }) => {
    const mapInstance = useMap();
    mapInstance.setView(center, zoom);
    return null;
  };
  const handleModalOpen = (geoLocalizacao) => {
    if (geoLocalizacao && geoLocalizacao.split(";").length > 1) {
      setCenterMap([
        geoLocalizacao.split(";")[0],
        geoLocalizacao.split(";")[1],
      ]);
      setpositionMarker([
        geoLocalizacao.split(";")[0],
        geoLocalizacao.split(";")[1],
      ]);
      set_modalMapaOpen(true);
    }
  };

  const loadOptionsAcoes = () => {
    api_GET("SetupSolicitacao/GetListByProtocolo/" + item.numeroProtocolo)
      .then((result) => set_list_acoes(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleOpenRequerimento = (rowData) => {
    if (
      (rowData.status == "Em Andamento" || rowData.status == "Divergente") &&
      showAcoesGestor == false
    ) {
      switch (rowData.setupSolicitacaoAcao.acao) {
        case "Novo Cadastro": {
          window.location =
            "/auth/DestinoRequerimento?protocolo=" + protocolo.numeroProtocolo;
          break;
        }
        case "Renovação":
          history.push({
            pathname: "/auth/DestinoRequerimentoRenovacao",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
              requerimento: rowData,
            },
          });
          break;
        case "Inclusão":
          history.push({
            pathname: "/auth/DestinoRequerimentoInclusaoLocal",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
              requerimento: rowData,
            },
          });
          break;
        case "Exclusão":
          history.push({
            pathname: "/auth/DestinoRequerimentoExclusaoLocal",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
              requerimento: rowData,
            },
          });
          break;
        case "Cancelamento":
          history.push({
            pathname: "/auth/RequerimentoCancelamento",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
              requerimento: rowData,
            },
          });
          break;
        case "Alteração":
          history.push({
            pathname: "/auth/DestinoRequerimentoAlteracao",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
              requerimento: rowData,
            },
          });
          break;
        case "Aumento de Capacidade":
          history.push({
            pathname: "/auth/DestinoRequerimentoAumentoCapacidade",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: rowData.setupSolicitacaoAcao,
              requerimento: rowData,
            },
          });
          break;
        case "Taxa FisLurb":
          history.push({
            pathname: '/auth/RequerimentoTaxaFislurb',
            state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
          });
          break;
        default:
          break;
      }
    } else {
      setLoading(true);
      api_GET("requerimento/" + rowData.requerimento_Id)
        .then((result) => set_requerimento(result.data))
        .catch((err) => showMessage("Aviso", err.message, "error", null))
        .finally(() => setLoading(false));
    }
  };

  const handleAtualizarContato = () => {
    history.push({
      pathname: "/auth/AtualizarContato",
      state: { protocolo: protocolo },
    });
  };

  const handleRequerimentoRenovarCadastro = (setupSolicitacaoAcao) => {
    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage("Aviso", "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }
    showQuestion("Atenção", "Quer criar um requerimento de renovação de cadastro?", "question",
      function (result) {
        if (result) {
          history.push({
            pathname: "/auth/DestinoRequerimentoRenovacao",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: setupSolicitacaoAcao,
            },
          });
        }
      }
    );
  };

  const handleRequerimentoAlterarCadastro = (setupSolicitacaoAcao) => {
    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage("Aviso", "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }
    showQuestion("Atenção", "Quer criar um requerimento de alteração de cadastro?", "question",
      function (result) {
        if (result) {
          history.push({
            pathname: "/auth/DestinoRequerimentoAlteracao",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: setupSolicitacaoAcao,
            },
          });
        }
      }
    );
  };

  const handleRequerimentoAumentoCapacidade = (setupSolicitacaoAcao) => {
    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage("Aviso", "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }
    showQuestion("Atenção", "Quer criar um requerimento de alteração de cadastro?", "question",
      function (result) {
        if (result) {
          history.push({
            pathname: "/auth/DestinoRequerimentoAumentoCapacidade",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: setupSolicitacaoAcao,
            },
          });
        }
      }
    );
  };

  const handleRequerimentoCancelamento = (setupSolicitacaoAcao) => {
    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage("Aviso", "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }
    showQuestion("Atenção", "Quer criar um requerimento de cancelamento de cadastro?", "question",
      function (result) {
        if (result) {
          history.push({
            pathname: "/auth/RequerimentoCancelamento",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: setupSolicitacaoAcao,
            },
          });
        }
      }
    );
  };

  const handleRequerimentoInclusaoLocal = (setupSolicitacaoAcao) => {
    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage("Aviso", "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }
    showQuestion("Atenção", "Quer criar um requerimento de inclusão de local de destinação?", "question",
      function (result) {
        if (result) {
          history.push({
            pathname: "/auth/DestinoRequerimentoInclusaoLocal",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: setupSolicitacaoAcao,
            },
          });
        }
      }
    );
  };

  const handleRequerimentoExclusaoLocal = (setupSolicitacaoAcao) => {
    if (protocolo.requerimento.some((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao?.toLowerCase() != "taxa fislurb" )){
      showMessage("Aviso", "Você possui um Requerimento em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
      return;
    }
    showQuestion("Atenção", "Quer criar um requerimento de exclusão de local de destinação?", "question",
      function (result) {
        if (result) {
          history.push({
            pathname: "/auth/DestinoRequerimentoExclusaoLocal",
            state: {
              protocolo: protocolo,
              setupSolicitacaoAcao: setupSolicitacaoAcao,
            },
          });
        }
      }
    );
  };

  const handleCancelarRequerimento = (item) => {
    setItemCancelamento(item);
    setModalCancelamento(true);
  };

  const handleRetornoCancelaRequerimento = (result) => {
    setLoading(false);
    showMessage(
      "Aviso",
      "Requerimento cancelado com sucesso!",
      "success",
      function () {
        window.location.reload();
      }
    );
  };

  const handleRequerimentoNovoCadastro = (setupSolicitacaoAcao) => {
    showQuestion(
      "Atenção",
      "Deseja criar requerimento de Novo Cadastro?",
      "question",
      function (result) {
        if (result) {
          setLoading(true);

          api_POST(
            `requerimento/PostNovoRequerimento/${protocolo.protocolo_Id}`
          )
            .then((result) => {
              showMessage(
                "Aviso",
                "Requerimento criado com sucesso! Preencha seus dados na tela seguinte.",
                "success",
                function () {
                  window.location.href = `/auth/DestinoRequerimento?protocolo=${protocolo.numeroProtocolo}`;
                }
              );
            })
            .catch((err) => showMessage("Aviso", err.message, "error", null))
            .finally(() => setLoading(false));
        }
      }
    );
  };


  const handleRequerimentoTaxaFislurb = (setupSolicitacaoAcao) => {
      if (protocolo.requerimento.filter((f) => f.status == "Em Andamento" && f?.setupSolicitacaoAcao?.acao == "Taxa FisLurb").length > 0) {
        showMessage("Aviso", "Você já possui um Requerimento de Taxa FisLurb em andamento. Conclua o requerimento ou efetue o cancelamento antes de iniciar um novo requerimento!", "error", null);
        return;
      }
      showQuestion("Atenção", "Deseja criar um requerimento de taxa fislurb?", "question",
          function (result) {
              if (result) {
                  history.push({
                      pathname: "/auth/RequerimentoTaxaFislurb",
                      state: {
                          protocolo: protocolo,
                          setupSolicitacaoAcao: setupSolicitacaoAcao,
                      },
                  });
              }
          }
      );
  }

  const handleReturnRequerimento = () => {
    set_requerimento(null);
  };

  const handleEmitirGuia = (requerimento_Id) => {
    let json_submit = {
      requerimento_Id: requerimento_Id,
      usuarioEmissao_Id: null,
    };

    setLoading(true);
    api_POST("AnaliseRequerimento/PostRequerimentoCobranca", json_submit)
      .then((result) =>
        showMessage(
          "Aviso",
          "Operação executada com sucesso!",
          "success",
          window.location.reload()
        )
      )
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    set_protocolo(item);
    loadOptionsAcoes();
  }, []);

  if (
    protocolo !== null &&
    protocolo.requerimento.length > 0 &&
    (session == null || (session && session.tipoAcesso == "Protocolo"))
  ) {
    const result = protocolo.requerimento.filter(
      (x) =>
        x.fluxoCadastroEtapaAtual !== null &&
        x.fluxoCadastroEtapaAtual.descricao === "Aguardando Compensação" &&
        x.setupSolicitacaoAcao.valorGuia > 0
    );
    if (result.length > 0) {
      showMessage(
        "Aviso",
        `Os pagamentos dos boletos não devem ser efetuados via Bancos Digitais, pois o Sistema da Prefeitura não reconhece esses pagamentos, e assim o cadastro não será liberado!
             Por favor, efetuar os pagamentos pelos bancos: Banco do Brasil, Bancoob, Banco Inter, Banco Original, Bradesco, Caixa, Daycoval, Itaú, Correspondentes Bancários, Rendimento, Safra, Santander.`,
        "warning",
        null
      );
    }
  }

  return (
    <>
      <ModalCancelamentoRequerimento
        visibilidadeModal={modalCancelamento}
        setVisibilidadeModal={() => setModalCancelamento(false)}
        item={itemCancelamento}
        onCancelado={() => window.location.reload()}
      />
      <div className="row">
        {session && session.tipoAcesso == "Protocolo" && (
          <div className="col-4 col-lg-4 text-start">
            <Button
              color="warning"
              onClick={() => {
                signOut(false, () => {
                  window.location.href = "/auth/meucadastro";
                });
              }}
            >
              <i class="fas fa-sign-out-alt"></i> Sair
            </Button>
          </div>
        )}
        {!showAcoesGestor && (
          <div className="col-8 col-lg-8 text-right">
            <Button color="info" onClick={() => handleAtualizarContato()}>
              <i class="fas fa-user"></i> Atualizar Contato
            </Button>
          </div>
        )}
      </div>
      {protocolo != null && requerimento == null && (
        <div>
          <Card>
            {protocolo?.requerimento?.filter(x =>
              x.fluxoCadastroEtapaAtual?.tipo === "Aguardando Aprovação de Guia" &&
              x.status === "Pendente" &&
              x.requerimentoTaxaFislurb != null &&
              x.requerimentoTaxaFislurb.some(rtf =>
                rtf.requerimentoTaxaFislurbBoletos.some(b => !!b.guiaArrecadacao && !b.DataPagamento)
              )
            ).length > 0 &&
              <Row>
                <Col lg="12">
                  <p className="text-danger">Guia da Taxa Fislurb disponível para pagamento</p>
                </Col>
              </Row>
            }
            <CardBody>
              {protocolo.status != "Ativo" && (
                <Row>
                  <Col lg="12">
                    <h5 className="text-danger">
                      * Cadastro {protocolo.status} no sistema
                    </h5>
                  </Col>
                </Row>
              )}
              <Row className="text-center">
                <Col lg="12">
                  <h2 className="titulo-solicitacao">
                    {
                      protocolo.setupSolicitacaoAcaoNovoCadastro
                        .setupSolicitacao.categoria.descricao
                    }
                  </h2>
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <h3 className="titulo-consulta">Empresa</h3>
                  <div className="line-protocolo"></div>
                </Col>
              </Row>
              <Row>
                <Col lg="6" sm="12">
                  <p>
                    <b>Fantasia:</b>{" "}
                    {protocolo.protocoloDestino[0].nome_Fantasia}
                  </p>
                </Col>
                <Col className="text-mobile" lg="6" sm="12">
                  <p>
                    <b>CNPJ/CPF:</b> {protocolo.cpf_Cnpj}
                  </p>
                </Col>
                <Col lg="5" sm="12">
                  <p>
                    <b>Razão Social:</b>{" "}
                    {protocolo.protocoloDestino[0].razaoSocial}
                  </p>
                </Col>
                <Col lg="2" sm="12">
                  <p>
                    <b>IM:</b>{" "}
                    {protocolo.protocoloDestino[0].inscricaoMunicipal}
                  </p>
                </Col>
                <Col lg="2" sm="12">
                  <p>
                    <b>CCM:</b> {protocolo.protocoloDestino[0].ccm}
                  </p>
                </Col>
                <Col lg="3" sm="12">
                  <p>
                    <b>Número Cadastro:</b> {protocolo.codigoCadastro}
                  </p>
                </Col>
                <Col lg="2" sm="12">
                  <p>
                    <b>CEP:</b> {protocolo.protocoloDestino[0].cep}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Endereço:</b>{" "}
                    {protocolo.protocoloDestino[0].logradouro +
                      ", " +
                      protocolo.protocoloDestino[0].numEndereco +
                      ", " +
                      protocolo.protocoloDestino[0].complemento}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Bairro:</b> {protocolo.protocoloDestino[0].bairro}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Cidade:</b> {protocolo.protocoloDestino[0].cidade}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Licença de Operação:</b>{" "}
                    {protocolo.protocoloDestino[0].numeroLicensaOperacao}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Tipo de Destino:</b>{" "}
                    {protocolo.protocoloDestino[0].tipoDestino}
                  </p>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Fim da Vigência:</b>{" "}
                    {protocolo.dataFimVigencia != null
                      ? formateDate(protocolo.dataFimVigencia)
                      : ""}
                  </p>
                </Col>
                {(protocolo?.setupSolicitacaoAcaoNovoCadastro?.setupSolicitacao?.categoria?.classificacao != "Banco Manejo" &&
                  protocolo?.setupSolicitacaoAcaoNovoCadastro?.setupSolicitacao?.categoria?.classificacao != "Especial") &&
                  <Col lg="12" sm="12">
                    <p>
                      <b>Bloquear Recebimento de CTR por capacidade excedida :</b>{" "}
                      {protocolo.protocoloDestino[0]
                        .bloquearRecebimentoCapacidadeExcedida
                        ? "Sim"
                        : "Não"}
                    </p>
                  </Col>
                }
                <Col lg="12" sm="12">
                  <p>
                    <b>Requer comprovar destinação na emissão da CTR :</b>{" "}
                    {protocolo.protocoloDestino[0].requerComprovacaoDestinacao
                      ? "Sim"
                      : "Não"}
                  </p>
                </Col>
                <Col lg="12" sm="12">
                  <p>
                    <b>Observações :</b>{" "}
                    {protocolo.protocoloDestino[0].observacaoManutencao}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <h3 className="titulo-consulta">Responsável</h3>
                  <div className="line-protocolo"></div>
                </Col>
              </Row>
              <Row>
                <Col lg="6" sm="12">
                  <h6 style={{ paddingTop: "5px" }}>
                    {protocolo.protocoloDestino[0].nomeResponsavel}
                  </h6>
                </Col>
                <Col className="text-mobile" lg="6" sm="12">
                  <h6 style={{ paddingTop: "5px" }}>{protocolo.email}</h6>
                </Col>
                <Col lg="6" sm="12">
                  <p>
                    <b>Telefone:</b> {protocolo.protocoloDestino[0].telefone}
                  </p>
                </Col>
                <Col lg="6" className="text-mobile" sm="12">
                  <p>
                    <b>Celular:</b> {protocolo.protocoloDestino[0].celular}
                  </p>
                </Col>
                <Col lg="12" sm="12">
                  <p>
                    <b>Responsável Técnico (CREA):</b> {protocolo.protocoloDestino[0]?.nomeResponsavelTecnico ?? ""}
                  </p>
                </Col>
              </Row>
              <Row>
                {protocolo != null &&
                  protocolo.status != "Pendente" &&
                  protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                    .categoria.sigla == "RGG" && (
                    <Col md="12" className="text-center">
                      <b>Carteirinha</b>
                      <br />
                      <i
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          window.open(
                            "/empty/CateirinhaDestinoRGG?protocolo=" +
                            protocolo.numeroProtocolo,
                            "_blank"
                          )
                        }
                        className="fas fa-qrcode fa-2x text-info"
                      ></i>
                    </Col>
                  )}
              </Row>
              <Row>
                {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao
                  .categoria.sigla != "RGG" && (
                    <Col lg="12">
                      <h3 className="titulo-consulta">Locais de Destinação</h3>
                      <div className="line-protocolo"></div>
                    </Col>
                  )}
              </Row>
              {protocolo.protocoloDestino[0].protocoloDestinoLocais.map(
                (item, key) => (
                  <div key={key}>
                    <Row md="12">
                      <Col md="9">
                        <b>Identificação:</b> <p>{item.identificacao}</p>
                      </Col>
                      <Col md="3">
                        <b>Status:</b> <p>{item.status}</p>
                      </Col>
                      <Col md="2">
                        <b>CEP:</b> <p>{item.cep}</p>
                      </Col>
                      <Col md="4">
                        <b>Endereço:</b>{" "}
                        <p>{item.logradouro + ", " + item.numEndereco}</p>
                      </Col>
                      <Col md="3">
                        <b>Bairro:</b> <p>{item.bairro}</p>
                      </Col>
                      <Col md="2">
                        <b>Capacidade:</b> <p>{item.capacidade + " m³"}</p>
                      </Col>
                      <Col md="9">
                        <b>Observação:</b> <p>{item.observacao}</p>
                      </Col>
                      {item.geoLocalizacao != null && (
                        <Col md="1">
                          <Button
                            color="info"
                            type="button"
                            onClick={() => handleModalOpen(item.geoLocalizacao)}
                          >
                            <i className="fas fa-map-marked-alt"></i>
                          </Button>
                        </Col>
                      )}
                      {protocolo != null && protocolo.status != "Pendente" && (
                        <Col md="12" className="text-center">
                          <b>Carteirinha</b>
                          <br />
                          <i
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              window.open(
                                "/empty/CertificadoDestino?protocolo=" +
                                protocolo.numeroProtocolo +
                                "&local=" +
                                item.protocoloDestinoLocal_Id,
                                "_blank"
                              )
                            }
                            className="fas fa-qrcode fa-2x text-info"
                          ></i>
                        </Col>
                      )}
                    </Row>
                    <hr />
                  </div>
                )
              )}
              <Row className="mb-2">
                <Col lg="12">
                  <h3 className="titulo-consulta">Classes de Resíduo</h3>
                  <div className="line-protocolo"></div>
                </Col>
                <Col lg="12">
                  {protocolo.protocoloDestino[0].protocoloDestinoClasseResiduos.map(
                    (item, key) => (
                      <div key={key}>
                        {item.classeResiduo.descricao}
                        <br />
                      </div>
                    )
                  )}
                </Col>
              </Row>
              {protocolo.protocoloDestino[0].protocoloDestinoTransportadores
                .length > 0 && (
                  <Row className="mb-2">
                    <Col lg="12">
                      <h3 className="titulo-consulta">
                        Transportadores Liberadores
                      </h3>
                      <div className="line-protocolo"></div>
                    </Col>
                    <Col lg="12">
                      {protocolo.protocoloDestino[0].protocoloDestinoTransportadores.map(
                        (item, key) => (
                          <div key={key}>
                            {item.protocoloTransportador.nome_Fantasia}
                            <br />
                          </div>
                        )
                      )}
                    </Col>
                  </Row>
                )}
              <Row>
                <Col lg="12">
                  <h3 className="titulo-consulta">Documentos</h3>
                  <div className="line-protocolo"></div>
                </Col>

                <MaterialTable
                  style={{ minHeight: "auto", width: "100%" }}
                  title=""
                  columns={[
                    { title: "Documento", field: "documento.descricao" },
                    { title: "Arquivo", field: "arquivo" },
                  ]}
                  data={protocolo.protocoloDocumentos}
                  isLoading={false}
                  options={{
                    filtering: false,
                    exportButton: true,
                  }}
                  actions={[
                    {
                      icon: "insert_drive_file",
                      tooltip: "Visualizar Documento",
                      onClick: (event, rowData) =>
                        window.open(
                          setupSistema?.caminhoVirtual + rowData.arquivo,
                          "_blank"
                        ),
                    },
                  ]}
                  localization={table_translate}
                />
              </Row>
              <Row className="mt-4">
                <Col lg="12">
                  <h3 className="titulo-consulta">Requerimentos</h3>
                  <div className="line-protocolo"></div>
                </Col>

                <MaterialTable
                  style={{ minHeight: "auto", width: "100%" }}
                  title=""
                  columns={[
                    { title: "Número", field: "numeroRequerimento" },
                    { title: "Tipo", field: "setupSolicitacaoAcao.acao" },
                    {
                      title: "Etapa",
                      field: "fluxoCadastroEtapaAtual.tipo",
                      render: (rowData) =>
                        rowData.fluxoCadastroEtapaAtual != null
                          ? rowData.fluxoCadastroEtapaAtual?.tipo
                          : "",
                    },
                    { title: "Status", field: "status" },
                    {
                      title: "Data Requerimento",
                      field: "dataCriacaoRequerimento",
                      render: (rowData) =>
                        formateDate(rowData.dataCriacaoRequerimento),
                    },
                    {
                      title: "Atualizado Em",
                      field: "dataUltimaAcao",
                      render: (rowData) =>
                        formateDateandTime(rowData.dataUltimaAcao),
                    },
                    {
                      title: "Data de Aceite",
                      field: "dataAceiteDeclaracao",
                      render: (rowData) =>
                        rowData.dataAceiteDeclaracao != null
                          ? formateDateandTime(rowData.dataAceiteDeclaracao)
                          : "",
                    },
                    {
                      title: "Data de Finalização",
                      field: "dataUltimaAcao",
                      render: (rowData) =>
                        rowData.dataUltimaAcao != null &&
                          rowData.status === "Finalizado"
                          ? formateDateandTime(rowData.dataUltimaAcao)
                          : "",
                    },
                  ]}
                  data={protocolo.requerimento.sort(function (a, b) {
                    return (
                      new Date(b.dataCriacaoRequerimento) -
                      new Date(a.dataCriacaoRequerimento)
                    );
                  })}
                  isLoading={false}
                  options={{
                    filtering: false,
                    exportButton: true,
                  }}
                  actions={[
                    {
                      icon: "insert_drive_file",
                      tooltip: "Visualizar Detalhes",
                      onClick: (event, rowData) =>
                        handleOpenRequerimento(rowData),
                    },
                    (rowData) => {
                      return (
                        (rowData.status == "Em Andamento" ||
                          rowData.status == "Divergente" ||
                          rowData.status == "Pendente") && {
                          icon: "cancel",
                          tooltip: "Cancelar Requerimento",
                          onClick: (event, rowData) =>
                            handleCancelarRequerimento(rowData),
                        }
                      );
                    },
                  ]}
                  localization={table_translate}
                />
              </Row>
              <Row className="mt-4">
                <Col lg="12">
                  <h3 className="titulo-consulta">Histórico de Alteração de E-mail</h3>
                  <div className="line-protocolo"></div>
                </Col>

                <MaterialTable
                  style={{ minHeight: "auto", width: "100%" }}
                  title=""
                  columns={[
                    { title: "Data/Hora", field: "dataHora", render: (rowData) => formateDateandTime(rowData.dataHora) },
                    { title: "Usuário", field: "nomeUsuario" },
                    { title: "E-mail Antigo", field: "emailAntigo" },
                    { title: "E-mail Atual", field: "emailAtual" },
                  ]}
                  data={protocolo?.protocoloHistoricoContatos}
                  isLoading={false}
                  options={{
                    filtering: false,
                    exportButton: true,
                  }}
                  localization={table_translate}
                />

              </Row>
              <div className="text-center">
                {modal && (
                  <ModalJustificativa
                    visibilidadeModal={modal}
                    setVisibilidadeModal={toggleModal}
                    item={item}
                  />
                )}
                {showAcoesGestor &&
                  item?.protocoloJustificativas.length > 0 && (
                    <Button color="warning" onClick={() => toggleModal()}>
                      <i className="fas fa-info mr-2"></i>
                      Justificativas Protocolo
                    </Button>
                  )}
                {showAcoesGestor == false &&
                  list_acoes != null &&
                  list_acoes.map((prop, key) => {
                    if (
                      (protocolo.status == "Ativo" || protocolo.status == "Pendente") &&
                      prop.acao == "Inclusão" &&
                      prop.setupSolicitacao.categoria.sigla == "RCC"
                    ) {
                      return (
                        <Button
                          color="info"
                          onClick={() => handleRequerimentoInclusaoLocal(prop)}
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }


                    if (protocolo.status == "Ativo" && 
                      prop.acao == "Taxa FisLurb" && 
                      (prop.setupSolicitacao.categoria.sigla == "RCC" || prop.setupSolicitacao.categoria.sigla == "RGG")) {
                      return (
                        <>
                          <Button
                            key={key}
                            color="warning"
                            onClick={() => handleRequerimentoTaxaFislurb(prop)}
                          >
                            {prop.identificacao}
                          </Button>
                        </>
                      );
                    }

                    if (
                      (protocolo.status == "Ativo" || protocolo.status == "Pendente") &&
                      prop.acao == "Exclusão" &&
                      prop.setupSolicitacao.categoria.sigla == "RCC"
                    ) {
                      return (
                        <Button
                          color="primary"
                          onClick={() => handleRequerimentoExclusaoLocal(prop)}
                        >
                          {" "}
                          {prop.identificacao}
                        </Button>
                      );
                    }

                    if (
                      prop.acao == "Renovação" &&
                      (protocolo.status == "Ativo" || protocolo.status == "Pendente" || protocolo.status == "Vencido" || protocolo.status == "Inativo") &&
                      (prop.setupSolicitacao.categoria.sigla == "RCC" || prop.setupSolicitacao.categoria.sigla == "RGG")
                    ) {
                      return (
                        <Button
                          color="success"
                          onClick={() =>
                            handleRequerimentoRenovarCadastro(prop)
                          }
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }

                    if (
                      prop.acao == "Cancelamento" &&
                      (protocolo.status == "Ativo" || protocolo.status == "Pendente" || protocolo.status == "Vencido" || protocolo.status == "Inativo")
                    ) {
                      return (
                        <Button
                          color="danger"
                          onClick={() => handleRequerimentoCancelamento(prop)}
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }
                  })}

                {showAcoesGestor == false &&
                  protocolo.status == "Ativo" &&
                  list_acoes != null &&
                  list_acoes.map((prop, key) => {
                    if (prop.acao == "Alteração") {
                      if (
                        protocolo.setupSolicitacaoAcaoNovoCadastro
                          .setupSolicitacao.categoria.classificacao ==
                        "Banco Manejo"
                      )
                        return (
                          <Button
                            key={key}
                            color="warning"
                            onClick={() =>
                              handleRequerimentoAlterarCadastro(prop)
                            }
                          >
                            {prop.identificacao}
                          </Button>
                        );
                      else
                        return (
                          <Button
                            key={key}
                            color="warning"
                            onClick={() =>
                              handleRequerimentoAlterarCadastro(prop)
                            }
                          >
                            {prop.identificacao}
                          </Button>
                        );
                    }
                  })}

                {showAcoesGestor == false &&
                  protocolo.status == "Ativo" &&
                  list_acoes != null &&
                  list_acoes.map((prop, key) => {
                    if (prop.acao == "Aumento de Capacidade") {
                      return (
                        <Button
                          key={key}
                          color="warning"
                          onClick={() =>
                            handleRequerimentoAumentoCapacidade(prop)
                          }
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }
                  })}

                {showAcoesGestor == false &&
                  protocolo.status == "Cancelado" &&
                  list_acoes != null &&
                  list_acoes.map((prop, key) => {
                    if (prop.acao == "Novo Cadastro") {
                      return (
                        <Button
                          key={key}
                          color="success"
                          onClick={() => handleRequerimentoNovoCadastro(prop)}
                        >
                          {prop.identificacao}
                        </Button>
                      );
                    }
                  })}

                {showAcoesGestor == false &&
                  protocolo?.requerimento?.filter(
                    (x) =>
                      x.status == "Pendente" &&
                      x.fluxoCadastroEtapaAtual !== null &&
                      x.fluxoCadastroEtapaAtual?.tipo?.toUpperCase() ==
                      "EMISSÃO DE GUIA"
                  ).length > 0 &&
                  setupSistema &&
                  setupSistema.metodologiaCobranca == "Integração PRODAM" && (
                    <Button
                      color="dark"
                      onClick={() =>
                        handleEmitirGuia(
                          protocolo?.requerimento?.filter(
                            (x) =>
                              x.status == "Pendente" &&
                              x.fluxoCadastroEtapaAtual !== null &&
                              x.fluxoCadastroEtapaAtual?.tipo?.toUpperCase() ==
                              "EMISSÃO DE GUIA"
                          )[0].requerimento_Id
                        )
                      }
                    >
                      Emitir Guia
                    </Button>
                  )}
              </div>
            </CardBody>
          </Card>
          <Modal
            centered
            isOpen={modalMapaOpen}
            toggle={() => set_modalMapaOpen(false)}
            zIndex="9999999"
          >
            <ModalBody className="md-bd">
              <h6>Localização no Mapa</h6>
              <Row className="mt-2">
                <Col lg="12">
                  <div id="map">
                    <MapContainer style={{ zIndex: "0" }}>
                      <ChangeMap center={centerMap} zoom={20}></ChangeMap>
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        opacity={0.5}
                      />
                      <Marker
                        position={positionMarker}
                        draggable={false}
                        icon={iconMarker}
                      ></Marker>
                    </MapContainer>
                  </div>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className="md-ft">
              <Button
                color="secondary"
                outline
                onClick={() => set_modalMapaOpen(false)}
              >
                Fechar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      )}
      {requerimento != null && (
        <FichaRequerimento
          item={requerimento}
          handleReturn={handleReturnRequerimento}
          showAcoesGestor={showAcoesGestor}
        />
      )}
    </>
  );
}
